import * as common from './common'

export const GlobalComponents = Vue =>
  Object.entries(common).forEach(([name, component]) => Vue.component(name, component))
